import FinalTreatmentHeader from "./Header";
import "./index.css";
import { useState } from "react";
import FinalTreatmentOwnContents from "./FinalTreatmentOwn";
import FinalTreatmentUnsoldContents from "./FinalTreatmentUnsold";
import FinalTreatmentPackagingContents from "./FinalTreatmentPackaging";
import { ShowHide } from "../components/ShowHideCompany";
import FlowNumbersBox from "../components/FlowNumbersBox";
const FinalTreatmentComponent = ({ businessId }) => {
  const [show, setShow] = useState(false);
  const [showBox, setShowBox] = useState(false);
  return (
    <div className="final-treatment-container" id="final-treatment-id">
      <FinalTreatmentHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />

        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 18"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && (
        <>
          <FinalTreatmentOwnContents
            businessId={businessId}
            category={"Product Own Not Received"}
          />
          <div
            className="cant-find-process-container"
            onClick={() => setShowBox(!showBox)}
          >
            <div className="cant-find-process">
              <div style={{ padding: "5px" }}>
                <h5>
                  If you wish to be more elaborate, fill out the following flow
                </h5>
              </div>
              <div className="cant-find-process-child">
                <h5>Click here</h5>
              </div>
            </div>
          </div>
        </>
      )}

      {showBox && (
        <>
          {show && (
            <FinalTreatmentOwnContents
              businessId={businessId}
              category={"Product Own Received"}
            />
          )}

          {show && (
            <FinalTreatmentPackagingContents
              businessId={businessId}
              category={"Product Packaging Not Received"}
            />
          )}
          {show && (
            <FinalTreatmentPackagingContents
              businessId={businessId}
              category={"Product Packaging Received"}
            />
          )}
          {show && (
            <FinalTreatmentUnsoldContents
              businessId={businessId}
              category={"Product Unsold Not Received"}
            />
          )}
          {show && (
            <FinalTreatmentUnsoldContents
              businessId={businessId}
              category={"Product Unsold Received"}
            />
          )}
        </>
      )}
    </div>
  );
};

export default FinalTreatmentComponent;
